module.exports = __webpack_public_path__ + "static/media/7.66c1b00a.svg";